/* istanbul ignore file */
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import { withRouter } from 'react-router';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import { selectedProtectionPlanWrapper } from 'yoda-site-components/lib/selectors/PdpNameSpaceSelector';
import { messagesActions } from 'yoda-site-components/lib/components/Messages';
import { messageTypes } from 'yoda-site-components/lib/components/Messages/Messages.config';
import FindStoresAction from 'yoda-site-components/lib/actions/FindStoresAction';
import { selectQueryParams } from 'yoda-site-components/lib/selectors/QuerySelector';
import AddToCartInterstitialLazy from 'yoda-checkout-components/lib/components/AddToCartInterstitial/AddToCartInterstitialLazy';
import OfferingsActions from 'yoda-checkout-components/lib/actions/OfferingsAction';
import Button from 'yoda-core-components/lib/components/Button';
import Loading from 'yoda-site-components/lib/components/Loading/Loading';
import { selectFeatureFlags } from 'yoda-site-components/lib/selectors/ContextSelector';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import LoaderAction from 'yoda-site-components/lib/actions/LoadingAction';
import ItemCountAction from 'yoda-site-components/lib/actions/ItemCountAction';
import selectPpId from 'yoda-site-components/lib/selectors/productDetails/selectPpId';
import {
    initProductOptions,
    getAdditionalServices,
    getSelectedProductSku,
} from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import selectAdditionalProtectionPlans from 'yoda-site-components/lib/selectors/protectionPlan/selectAdditionalProtectionPlans';
import MyAlertsTooltipWrapper from 'yoda-site-components/lib/components/MyAlertsTooltip/MyAlertsTooltipWrapperLazy';
import MyAlertsModalAction from 'yoda-site-components/lib/actions/MyAlertsModalAction';
import * as ATCInterstitalActions from 'yoda-site-components/lib/actions/ATCInterstitalAction';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import withAddToCartHOC from './withAddToCartHOC';
import * as styles from './AddToCart.css';
import {
    ADD_TO_CART_MESSAGES_ID,
    ADD_TO_CART_COMMON_MESSAGE_ID,
    STORE_MODAL_ADD_TO_CART_MESSAGES_ID,
} from './AddToCart.config';
import {
    addToCartOnClick,
    addToCartStickyOnClick,
    closeCartModal,
} from '../../actions/AddToCartAction';
import {
    formErrorAnalytics,
    cartUpdateAnalytics,
    openModalAnalytics,
    cartAddAnalytics,
    carePlanAcceptAnalytics,
    carePlanViewAnalytics,
    selectOptionsAnalytics,
} from '../../actions/AnalyticsAction';
import scrollToElement from '../../scrolling';
import selectSkuId from '../../selectors/selectedByUser/selectSkuId';
import ProductConstants, { atcErrorCodes } from '../../helpers/ProductConstants';
import validateAddToCartForm, {
    checkItemAvailability,
    isValidATCForm,
} from '../../validation/isValidAddToCart';
import {
    DEFAULT_ERROR_BANNER_MESSAGE,
    ERROR_BANNER,
    getErrorATCMessage,
    parseBannerCustomMessage,
    ERROR_CUSTOM_BANNER,
} from '../../validation/bannerUtils';
import deliveryOptions from '../../selectors/delivery/deliverOptionsSelector';
import getMyAlerts from '../../selectors/AddToCartSelector';
import { selectSkuIds } from '../../selectors/Bundle/BundleProductOptionsSelector';
import getDeliveryDateType from '../../helpers/GetDeliveryDateType';
import { scrollToFirstMessage } from '../../helpers/AddToHelpers';

const cx = classNames.bind(styles);

let includedProtectionPlan = [];

const isProductAdded = false; // this is to avoid calling ATC mutiple times when store API success
export class AddToCart extends SiteComponent {
    static propTypes = {
        automationId: PropTypes.string,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        addToCart: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        selectedQuantity: PropTypes.number,
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        customOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        ppId: PropTypes.string,
        skuId: PropTypes.string,
        errorBannerMessage: PropTypes.string,
        updateErrorBannerMessage: PropTypes.func,
        deliveryZipcode: PropTypes.string,
        deliveryOption: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        customOptionsFieldsErrors: PropTypes.array,
        addToCartMessages: PropTypes.oneOfType([PropTypes.array]),
        selectedProtectionPlan: PropTypes.string,
        messagesTexts: PropTypes.oneOfType([PropTypes.object]),
        query: PropTypes.oneOfType([PropTypes.object]),
        selectedProductLot: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        sticky: PropTypes.bool,
        additionalProtectionPlans: PropTypes.oneOfType([PropTypes.array]),
        addToCartInterstitialDetails: PropTypes.oneOfType([PropTypes.object]),
        productCollection: PropTypes.oneOfType([PropTypes.array]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        myAlert: PropTypes.oneOfType([PropTypes.object]),
        stickyHeaderCallBack: PropTypes.func,
        selectedSkuIds: PropTypes.oneOfType([PropTypes.array]),
        additionalServices: PropTypes.oneOfType([PropTypes.array]),
        addProductToCart: PropTypes.func,
        getDeliveryOptionDetails: PropTypes.func,
        sdpuStoreInfo: PropTypes.oneOfType([PropTypes.object]),
        findStoresDetails: PropTypes.object,
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        queryParams: PropTypes.oneOfType([PropTypes.object]),
        selectedSkuId: PropTypes.string,
        sdpuStoreDetails: PropTypes.oneOfType([PropTypes.object]),
        deliveryOptionsName: PropTypes.string,
        storeFetchStatus: PropTypes.string,
        location: PropTypes.oneOfType([PropTypes.object]),
        router: PropTypes.oneOfType([PropTypes.object]),
        serviceErrors: PropTypes.oneOfType([PropTypes.object]),
        isNative: PropTypes.bool,
        isAddEditSlider: PropTypes.oneOfType([PropTypes.object]),
        isLoading: PropTypes.bool,
    };

    static defaultProps = {
        automationId: '',
        actions: {},
        addToCart: {
            isAddToCartSuccess: false,
            isUpdateCartSuccess: false,
        },
        selectedQuantity: 1,
        productOptions: {},
        customOptions: [],
        ppId: '',
        skuId: '',
        deliveryZipcode: '',
        deliveryOption: {},
        customOptionsFieldsErrors: [],
        addToCartMessages: [],
        selectedProtectionPlan: '',
        messagesTexts: {},
        query: {},
        selectedProductLot: [],
        additionalProtectionPlans: [],
        sticky: false,
        addToCartInterstitialDetails: {},
        productCollection: [],
        featureFlags: {},
        myAlert: {},
        stickyHeaderCallBack: null,
        selectedSkuIds: [],
        additionalServices: [],
        addProductToCart: null,
        getDeliveryOptionDetails: null,
        sdpuStoreInfo: {},
        findStoresDetails: {},
        productDetails: {},
        queryParams: {},
        selectedSkuId: '',
        sdpuStoreDetails: {},
        deliveryOptionsName: '',
        storeFetchStatus: '',
        location: {},
        router: {},
        serviceErrors: {},
        isNative: false,
        isAddEditSlider: {},
        isLoading: false,
        updateErrorBannerMessage: () => {},
        errorBannerMessage: null,
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);

        this.isAnimation = false;
        this.storesInfo = []; // This is rquired to check item availablity on stores when store API success
        this.isAtcFindStores = false;
    }

    state = {
        belowViewport: true,
        tooltipEnabled: this.props.deviceType.isDesktop,
        isChangeStorePrompted: false,
        promptSelectedStore: {},
        isValidationFailed: false,
        enableATC: true,
    };

    componentWillReceiveProps(nextProps) {
        const {
            addToCart,
            myAlert,
            storeFetchStatus,
            findStoresDetails,
            serviceErrors,
            messagesTexts: { AddToCartMessages },
            productOptions: { dimensions, optionsSelected },
            errorBannerMessage,
            customOptionsFieldsErrors,
            updateErrorBannerMessage,
            ppId,
        } = nextProps;

        /* istanbul ignore next */
        const {
            addToCartInterstitialDetails,
            cartDetails = {
                childItems: [],
            },
            addToCart: { isAddToCartSuccess, isUpdateCartSuccess },
            actions,
            productCollection,
            featureFlags: { enableErrorSizing },
        } = this.props;
        /* istanbul ignore else */
        if (addToCart.isUpdateCartSuccess && !isUpdateCartSuccess) {
            this.triggerCartAddAnalytics([].concat(cartDetails), nextProps);
            this.carePlanViewAnalytics();
            this.carePlanAcceptAnalytics();
            this.redirectToCart();
        }
        if (ppId !== this.props.ppId) {
            this.setState({
                enableATC: true,
            });
        }
        /* istanbul ignore next */
        if (
            !isEqual(nextProps.addToCartInterstitialDetails, addToCartInterstitialDetails) &&
            isAddToCartSuccess
        ) {
            actions.closeSlidePanel();
            if (isEmpty(addToCartInterstitialDetails)) {
                this.triggerCartAddAnalytics([].concat(cartDetails), nextProps);
                this.carePlanViewAnalytics();
                this.carePlanAcceptAnalytics();
            } else if (addToCartInterstitialDetails.bag) {
                // To verify if the current product is a collection.
                // addToCartInterstitialDetails is not empty for products that are part of collection.
                if (productCollection && productCollection.length > 0) {
                    this.carePlanViewAnalytics();
                    this.carePlanAcceptAnalytics();
                }
                const orderItem = find(addToCartInterstitialDetails.bag.items, {
                    sku: { id: cartDetails.skuId },
                });
                if (
                    !orderItem ||
                    nextProps.addToCartInterstitialDetails.bag.itemCount >
                        addToCartInterstitialDetails.bag.itemCount
                ) {
                    this.triggerCartAddAnalytics([].concat(cartDetails), nextProps);
                }
            }
        }
        if (enableErrorSizing) {
            const isValidAddToCart = isValidATCForm(this.props, null);
            if (myAlert.isOOSPro) {
                if (errorBannerMessage === nextProps?.errorBannerMessage && errorBannerMessage) {
                    updateErrorBannerMessage('');
                }
            }
            if (isValidAddToCart.messages.length === 0 && customOptionsFieldsErrors.length === 0) {
                this.setState({
                    enableATC: true,
                });
                if (errorBannerMessage === nextProps?.errorBannerMessage && errorBannerMessage) {
                    updateErrorBannerMessage('');
                }
            }
        }
        /* istanbul ignore next */
        if (myAlert.isOfferingCall) {
            if (myAlert.isGetInStock !== this.props.myAlert.isGetInStock) {
                this.isAnimation = true;
            }
        }
        const serviceErrorCode = get(serviceErrors, 'errors.errorCode', '');
        const prevServiceErrorCode = get(this.props.serviceErrors, 'errors.errorCode', '');
        if (
            (addToCart.isAddToCartSuccess || addToCart.isUpdateCartSuccess) &&
            serviceErrorCode === atcErrorCodes.SRV_PRICE_FALLBACK_FAILED &&
            prevServiceErrorCode !== serviceErrorCode
        ) {
            this.props.actions.addMessage({
                section: ADD_TO_CART_MESSAGES_ID,
                message: {
                    id: ADD_TO_CART_COMMON_MESSAGE_ID,
                    title: AddToCartMessages.atcSuccess,
                    type: messageTypes.success,
                },
                sourceMiniPDP: false,
            });
        }
    }

    componentDidMount() {
        if (this.props.sticky) {
            // give min height to avoid jump when button moves from inline to fixed.
            /* istanbul ignore next */
            if (this.addToCartButtonContainer && this.addToCartButtonContainer.style) {
                this.addToCartButtonContainer.style.minHeight = `${this.addToCartButtonContainer.offsetHeight}px`;
            }

            /* istanbul ignore next */
            if (this.addToCartButtonBlock && this.addToCartButtonBlock.offsetHeight > 0) {
                document.body.style.paddingBottom = `${
                    this.addToCartButtonBlock.offsetHeight + 5
                }px`;
            }
        }
    }

    shouldComponentUpdate(nextProps) {
        const { myAlertsNew = true } = this.props.featureFlags;
        const { productDetails } = nextProps;
        const congruentPPsDetails = get(productDetails, 'congruentDimensions', []);
        /* istanbul ignore next */
        if (
            myAlertsNew &&
            this.props.myAlert.deliveryOptionRequired &&
            nextProps.myAlert.isSelectedItemInStock === '' &&
            congruentPPsDetails?.length === 0
        ) {
            return false;
        }
        return true;
    }

    redirectToCart = () => {
        const checkoutUrl = ProductConstants.CHECKOUT_URL;
        window.location.pathname = checkoutUrl;
    };

    triggerCarePlanAcceptAnalytics = (selectedSKU, ppId) => {
        const warrantyPrice = this.props.selectedProductLot[0]
            ? find(this.props.selectedProductLot[0].warranties, { itemId: selectedSKU })
            : false;
        const lotId = (selectedSKU || '').slice(0, 7);
        const productInfo = {
            productPPID: ppId || this.props.ppId,
            productLotId: [lotId],
            productSKU: selectedSKU,
            productCurrentSellingPrice:
                warrantyPrice && warrantyPrice.price
                    ? Number(warrantyPrice.price).toFixed(2)
                    : '0.00',
        };
        this.props.actions.carePlanAcceptAnalytics([].concat({ productInfo }));
    };

    getDeliveryDateAnalytics() {
        const { deliveryOption } = this.props;
        const deliveryDateForAnalytics = get(
            deliveryOption,
            'shipToHomeOrStore.expDeliveryDate',
            ''
        );
        let deliveryDayType = '';
        let deliveryDays = '';

        /* istanbul ignore next */
        if (get(deliveryOption, 'shipToHomeOrStore.isChecked', false)) {
            deliveryDayType = get(deliveryOption, 'shipToHomeOrStore.deliveryMessage', false)
                ? getDeliveryDateType(deliveryOption.shipToHomeOrStore.deliveryMessage)
                : '';

            deliveryDays = get(deliveryOption, 'shipToHomeOrStore.difference_In_Days', 0);

            return {
                deliveryDayType,
                deliveryDays,
                deliveryDateForAnalytics,
            };
        }

        return {
            deliveryDayType,
            deliveryDays,
            deliveryDateForAnalytics,
        };
    }

    getClickPosition = (deliveryMethod) => {
        const { sticky, isOpenSubSlidePanel } = this.props;

        if (!this.state.belowViewport && sticky) {
            return 'add to bag|pdp|sticky';
        }
        if (deliveryMethod === ProductConstants.SAMEDAYPICKUP && !isOpenSubSlidePanel) {
            return 'add to bag|pdp|modal';
        }

        return 'add to bag|pdp|main';
    };

    triggerCartAddAnalytics = (cartItems, { addToCart: nextPropsAddToCart = {} }) => {
        const { query, deliveryOption, getDeliveryOptionDetails, isOpenSubSlidePanel } = this.props;

        const deliveryOptionDetails = getDeliveryOptionDetails();
        const maxQuantityMsgDisplay =
            (deliveryOption &&
                deliveryOption.shipToHomeOrStore &&
                deliveryOption.shipToHomeOrStore.quantityReachMaxPosition) ||
            false;
        const {
            deliveryDayType,
            deliveryDays,
            deliveryDateForAnalytics,
        } = this.getDeliveryDateAnalytics();

        let deliveryMethod = '';

        if (deliveryOptionDetails.type === 'HOME') {
            deliveryMethod =
                deliveryOptionDetails.label === ProductConstants.SHIPTOSTORE
                    ? ProductConstants.SHIPTOHOMEORSTORE
                    : deliveryOptionDetails.label;
        } else {
            deliveryMethod = ProductConstants.SAMEDAYPICKUP;
        }
        /* istanbul ignore next */
        const clickPosition = this.getClickPosition(deliveryMethod);

        /* istanbul ignore next */
        if (nextPropsAddToCart.isStoreModalAtc !== true) {
            if (query.cartId) {
                const productPreviousQuantity = query.qty;
                const productPreviousSku = query.selectedSKUId || query.sku;
                const previousDeliveryMethod = query.deliveryOption;
                let prevDeliveryMethod;
                if (previousDeliveryMethod === 'HOME') {
                    prevDeliveryMethod =
                        deliveryOptionDetails &&
                        deliveryOptionDetails.label === ProductConstants.SHIPTOSTORE
                            ? ProductConstants.SHIPTOHOMEORSTORE
                            : deliveryOptionDetails.label;
                    prevDeliveryMethod = prevDeliveryMethod || 'ship to home';
                } else {
                    prevDeliveryMethod = ProductConstants.SAMEDAYPICKUP;
                }
                this.props.actions.cartUpdateAnalytics({
                    deliveryMethod,
                    productPreviousQuantity,
                    cartItems,
                    productPreviousSku,
                    maxQuantityMsgDisplay,
                    prevDeliveryMethod,
                });
            } else if (!isOpenSubSlidePanel) {
                this.props.actions.cartAddAnalytics({
                    deliveryMethod,
                    cartItems,
                    clickPosition,
                    maxQuantityMsgDisplay,
                    deliveryDayType,
                    deliveryDays,
                    deliveryDateForAnalytics,
                });
                this.props.actions.openModalAnalytics('cart interstitial');
            }
        }
    };

    removeLoader = () => {
        this.props.actions.removeLoader();
    };

    carePlanViewAnalytics() {
        const {
            ppId,
            selectedProtectionPlan,
            productOptions: { selectedProductLot },
        } = this.props;
        /* istanbul ignore next */
        if (!isEmpty(selectedProtectionPlan)) {
            let lotId = '';
            if (selectedProtectionPlan === 'no') {
                lotId = selectedProductLot[0].id;
            } else {
                lotId = selectedProtectionPlan.slice(0, 7);
            }
            this.props.actions.carePlanViewAnalytics(
                [].concat({
                    productInfo: {
                        productLotId: [lotId],
                        productPPID: ppId,
                    },
                })
            );
        }
    }

    carePlanAcceptAnalytics() {
        const { ppId, selectedProtectionPlan } = this.props;
        /* istanbul ignore next */
        if (!isEmpty(selectedProtectionPlan) && selectedProtectionPlan !== 'no') {
            this.triggerCarePlanAcceptAnalytics(selectedProtectionPlan, ppId);
        }
    }

    validateATCFormFields(options) {
        const { customOptions, customOptionsFieldsErrors } = this.props;
        const result = validateAddToCartForm(this.props, options);
        this.setState({
            isValidationFailed: true,
        });
        document.activeElement.blur();
        if (customOptions.options && !isEmpty(customOptionsFieldsErrors)) {
            const errorcustomMessage = parseBannerCustomMessage(customOptionsFieldsErrors);
            result.messages.push({
                section: ERROR_CUSTOM_BANNER,
                message: {
                    id: ERROR_CUSTOM_BANNER,
                    title: errorcustomMessage[0],
                    options: errorcustomMessage[1],
                    type: 'warning',
                },
            });
            result.invalid = true;
        }
        return result;
    }

    formErrorValidation(addToCartFormValidationResult) {
        const isFormValidation = true;

        this.getInfoMessages(addToCartFormValidationResult, isFormValidation);

        setImmediate(scrollToFirstMessage);
    }

    removeAtcErrorMsg = () => {
        this.props.actions.removeAllMessages({
            section: STORE_MODAL_ADD_TO_CART_MESSAGES_ID,
            sourceMiniPDP: false,
        });
    };

    itemAvailabilityOnStore = () => {
        const { sdpuStoreDetails, actions } = this.props;
        /* istanbul ignore next */
        const promptSelectedStore =
            this.storesInfo.length &&
            find(this.storesInfo, (store) => store.id === sdpuStoreDetails.id);
        const itemUnavailableStore =
            (promptSelectedStore || {}).items &&
            find(
                promptSelectedStore.items,
                (item) => item.inventory.pickUpStatus === 'UNAVAILABLE'
            );
        /* istanbul ignore next */
        if (itemUnavailableStore) {
            this.setState({
                isChangeStorePrompted: true,
                promptSelectedStore,
            });
            actions.openSlidePanel();
            actions.openSubSlidePanel();
            this.removeAtcErrorMsg();
        }
        return itemUnavailableStore;
    };

    performAddToCart = ({ displayChangeStorePrompt = false, isChangeStoreAtc = false }) => {
        const {
            addProductToCart,
            sdpuStoreInfo: { name, id, zipCode },
            selectedSkuIds,
            deliveryOptionsName: { selectedOption = '' },
            actions,
        } = this.props;
        const sdpuStoreInfo = {
            storeId: id,
            storeName: name,
            zipCode,
        };
        /* istanbul ignore next */

        this.setState({
            isChangeStorePrompted: false,
            isValidationFailed: false,
        });
        addProductToCart(selectedSkuIds, sdpuStoreInfo, isChangeStoreAtc);
    };

    onAddToCartClick = (e) => {
        e.preventDefault();
        const {
            actions,
            selectedSkuIds,
            sdpuStoreInfo: { zipCode },
            featureFlags: { disableProtectionPlan = true, enableErrorSizing },
            deliveryOptionsName: { selectedOption = '' },
            productOptions: { filteredItems, dimensions, optionsSelected },
            messagesTexts: { AddToCartMessages },
            updateErrorBannerMessage,
            customOptionsFieldsErrors,
        } = this.props;
        const shouldValidateProtectionPlan = disableProtectionPlan
            ? {
                  ignoreProtectionPlan: true,
              }
            : {};
        const addToCartFormValidationResult = this.validateATCFormFields(
            shouldValidateProtectionPlan
        );
        /* istanbul ignore if */
        actions.addToCartOnClick();

        if (addToCartFormValidationResult.invalid) {
            this.setState({
                isValidationFailed: true,
            });
            if (enableErrorSizing) {
                this.setState({
                    enableATC: false,
                });
                const errorBannerList = addToCartFormValidationResult.messages.filter(
                    (item) => item.section === ERROR_BANNER || item.section === ERROR_CUSTOM_BANNER
                );
                const errorATCMessage = getErrorATCMessage(errorBannerList);

                updateErrorBannerMessage(errorATCMessage || DEFAULT_ERROR_BANNER_MESSAGE);
                // return;
            }

            document.activeElement.blur();
            this.formErrorValidation(addToCartFormValidationResult);
            return;
        }

        if (selectedSkuIds.length) {
            actions.showLoader();
            /* istanbul ignore next */

            this.isAtcFindStores = false;
            this.performAddToCart({});
        } else {
            actions.addMessage({
                section: ADD_TO_CART_MESSAGES_ID,
                message: {
                    id: ADD_TO_CART_COMMON_MESSAGE_ID,
                    title: AddToCartMessages.inventoryUnavailable,
                },
                sourceMiniPDP: false,
            });
        }
    };

    stickyHeaderAlertClick = () => {
        this.props.stickyHeaderCallBack();
    };

    onMyAlertsClick = () => {
        const {
            sticky,
            actions: { updateMyAlertsSlot },
        } = this.props;
        const addToCartFormValidationResult = this.validateATCFormFields({
            ignoreProtectionPlan: true,
        });
        /* istanbul ignore next */
        if (!this.state.belowViewport && sticky && this.addToCartButtonContainer) {
            const customOffset = this.addToCartButtonContainer.offsetTop - 235;
            scrollToElement(this.addToCartButtonContainer, customOffset);
        }
        /* istanbul ignore if */
        if (!addToCartFormValidationResult.invalid) {
            updateMyAlertsSlot({ slot: 'cta', sourceMiniPDP: false });
        } else {
            this.formErrorValidation(addToCartFormValidationResult);
        }
    };

    closeCartModal = () => {
        this.props.actions.updateItemCountAction();
        this.props.actions.closeCartModal({
            stickyHeaderOnClick: this.props.addToCart.stickyHeaderOnClick,
        });
    };

    getWarrantyDetails = () => {
        const {
            productOptions: { selectedProductLot },
            selectedProtectionPlan,
            actions,
            isAddEditSlider: { isAddorEdit = false },
            isNative,
        } = this.props;
        const warranties = [];
        /* istanbul ignore next */
        if (
            selectedProductLot.length &&
            selectedProductLot[0].warranties &&
            selectedProductLot[0].warranties.length
        ) {
            const additionalProtectionPlan = selectedProductLot[0].warranties.filter(
                (warranty) => !warranty.selected
            );
            includedProtectionPlan = selectedProductLot[0].warranties.filter(
                (warranty) => warranty.selected
            );
            /* sort protection plans from BAPI based on price */
            get(selectedProductLot[0], 'warranties', []).sort(
                /* istanbul ignore next */ (a, b) => b.price - a.price
            );
            additionalProtectionPlan.forEach((warranty) => {
                warranties.push({
                    id: warranty.itemId,
                    type: 'service',
                    group: 'care plan',
                    required: true,
                    selected: warranty.itemId === selectedProtectionPlan,
                    name: warranty.name,
                    description: warranty.description,
                    price: warranty.price,
                });
            });
            isNative && !isAddorEdit && actions.setATCAddEdit();
        }
        return warranties;
    };

    enteredViewport = () => {
        this.setState({
            belowViewport: true,
        });
    };

    leftViewport = ({ currentPosition }) => {
        /* istanbul ignore else */
        if (currentPosition === 'above') {
            this.setState({
                belowViewport: false,
            });
        } else {
            this.setState({
                belowViewport: true,
            });
        }
    };

    renderCartSuccessModal() {
        document.activeElement.blur();
        return (
            <ErrorBoundary>
                <AddToCartInterstitialLazy
                    sku={this.props.selectedSkuIds}
                    deliveryServiceInfo={this.props.additionalServices}
                    showAddToCart={this.props.addToCart.isAddToCartSuccess}
                    ppId={this.props.ppId}
                    onCloseAddToCart={this.closeCartModal}
                    carePlanInfo={this.getWarrantyDetails()}
                    careplanAcceptAnalyticsFunc={this.triggerCarePlanAcceptAnalytics}
                    warrantyDetails={
                        includedProtectionPlan[0] ? includedProtectionPlan[0].description : ''
                    }
                    numberOfItems={this.props.selectedQuantity}
                    removeLoader={this.removeLoader}
                    pdpAddToCart
                />
            </ErrorBoundary>
        );
    }

    onSelectOptionsClick = () => {
        const scrollToElem =
            document.getElementsByClassName('GlobalOptions-Container')[0] ||
            document.getElementsByTagName('body')[0];
        const { actions } = this.props;
        const validationResult = this.validateATCFormFields();

        this.getInfoMessages(validationResult);

        actions.selectOptionsAnalytics();

        /* istanbul ignore next */
        if (scrollToElem) {
            scrollToElement(scrollToElem, scrollToElem.offsetTop);
        }
    };

    getInfoMessages = (validationResult, isFormValidation = false) => {
        const { actions } = this.props;
        const formErrors = [];

        if (validationResult && validationResult.messages && validationResult.messages.length) {
            validationResult.messages.forEach((error) => {
                error.message.type = 'warning';
                actions.addMessage({ ...error, sourceMiniPDP: false });
                const errorMsgTitle = get(error.message, 'title', '').toLowerCase();
                const isDuplicateErrorMsg =
                    formErrors.find((errorMsg) => errorMsg.errorDescription === errorMsgTitle) ||
                    false;
                if (isFormValidation && !isDuplicateErrorMsg) {
                    formErrors.push({ errorDescription: errorMsgTitle });
                }
            });

            isFormValidation && actions.formErrorAnalytics(formErrors);
        }
    };

    loadAnimationClass = (isGetInStock) =>
        isGetInStock ? ['zeroTop', 'textDownAnimation'] : 'textUpAnimation';

    // Renders change store prompt(CSP) when BOPIS selected
    renderCspOrAtcInterstitial = () => {
        const { addToCart } = this.props;
        /* istanbul ignore next */

        if (addToCart.isAddToCartSuccess) {
            return this.renderCartSuccessModal();
        }
        return null;
    };

    render() {
        const {
            automationId,
            sticky,
            featureFlags,
            myAlert: { isOOSPro, buttonText, isGetInStock },
            deviceType,
            isLoading,
        } = this.props;
        const { belowViewport, isValidationFailed } = this.state;
        const { isItemAvailable } = checkItemAvailability(this.props);
        const { myAlertsNew = true } = featureFlags;
        const CTAButtonContainer = (
            <Button
                size="Lg"
                buttonType={isOOSPro ? 'Secondary' : 'Primary'}
                automationId={automationId}
                className={cx({
                    addToCartBtn: true,
                })}
                isDisabled={
                    (featureFlags.enableErrorSizing && !this.state.enableATC) ||
                    isOOSPro ||
                    (!myAlertsNew && !isItemAvailable)
                }
                onClick={isGetInStock ? this.onMyAlertsClick : this.onAddToCartClick}
            >
                {isOOSPro || !myAlertsNew ? (
                    <span className={cx('btnText')}>{buttonText}</span>
                ) : (
                    <div
                        className={[
                            cx(myAlertsNew ? 'btnTxtContainerNoRelative' : 'btnTxtContainer'),
                            dt(['smOnly:whitespace-nowrap']),
                        ].join(' ')}
                    >
                        {!myAlertsNew && (
                            <p
                                data-automation-id="getInStock"
                                className={`${cx(
                                    'btnText',
                                    { zeroTop: isGetInStock },
                                    this.isAnimation && this.loadAnimationClass(isGetInStock)
                                )} ${dt(['flex', 'items-center', 'justify-center'])}`}
                            >
                                Get In Stock Alert
                            </p>
                        )}
                        <p
                            data-automation-id="addToCart"
                            className={`${cx(
                                'btnText',
                                { zeroTop: isGetInStock },
                                this.isAnimation && this.loadAnimationClass(isGetInStock)
                            )} ${dt(['flex', 'items-center', 'justify-center'])}`}
                        >
                            {buttonText}
                        </p>
                    </div>
                )}
            </Button>
        );

        /* if (
            (!get(featureFlags, 'disableStickyHeader', true) && !belowViewport && sticky) ||
            isStickyHeader
        ) {
            const requiredFields = validateAddToCartForm(this.props);
            /!* istanbul ignore if *!/
            if (!get(featureFlags, 'enableSKUAvailabilityLogic', true) && isOOSPro) {
                CTAButtonContainer = null;
            } /!* istanbul ignore if *!/ else if (requiredFields.invalid) {
                CTAButtonContainer = (
                    <Button
                        size="large"
                        preset={isOOSPro ? 'secondary' : 'primary'}
                        className={cx({
                            stickyAddToCartBtn: true,
                        })}
                        automationId="select-options"
                        onClick={this.onSelectOptionsClick}
                    >
                        <span className={cx('btnSelectOption')}>Select Options</span>
                    </Button>
                );
            }
        } */
        const buttonContainerStyle = dt(['my-0', 'mx-0']);
        return (
            <div className={cx('wrapper', 'sm12', 'md12', 'lg12', 'xl12')}>
                {sticky ? (
                    <Waypoint
                        onEnter={this.enteredViewport}
                        onLeave={this.leftViewport}
                        topOffset={-62}
                        bottomOffset={72}
                        fireOnRapidScroll={false}
                    />
                ) : null}
                <MyAlertsTooltipWrapper slot="cta" fromMiniPDP={false} />
                <div
                    className={cx('buttonContainer', buttonContainerStyle)}
                    ref={(el) => {
                        this.addToCartButtonContainer = el;
                    }}
                >
                    <div
                        data-automation-id="addToCartBlock"
                        {...(get(featureFlags, 'enableConstructorIO', true) && {
                            'data-cnstrc-btn': 'add_to_cart',
                        })}
                        id="GlobalOptions-AddToCart"
                        className={cx('addToCartBlock', {
                            [styles.addToCartSticky]:
                                !belowViewport && sticky && !featureFlags.disableStickyHeader,
                        })}
                        ref={(el) => {
                            this.addToCartButtonBlock = el;
                        }}
                    >
                        {get(featureFlags, 'enableSKUAvailabilityLogic', true) &&
                            isLoading &&
                            isLoading.customLoader && (
                                <div className={[cx('placeHolder', 'm-auto')].join(' ')}>
                                    <Loader />
                                </div>
                            )}
                        {CTAButtonContainer}
                    </div>
                </div>
                {this.renderCspOrAtcInterstitial()}
                <Loading />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    ppId: selectPpId(state),
    addToCart: state.addToCart,
    selectedQuantity: parseInt(state.selectedQuantity, 10),
    additionalServices: getAdditionalServices(false)(state),
    productOptions: initProductOptions(ownProps.fromMiniPDP)(state),
    selectProductOption: state.productOptions,
    customOptions: state.customOptions,
    skuId: selectSkuId(state),
    deliveryZipcode: state.deliveryZipcode,
    deliveryOption:
        Object.keys(deliveryOptions(state).shipToHomeOrStore).length > 0
            ? deliveryOptions(state)
            : state.deliveryOption,
    promiseDeliveryOptions: deliveryOptions(state),
    addToCartMessages: state.messages[ADD_TO_CART_MESSAGES_ID],
    customOptionsFieldsErrors: state.messages.CUSTOM_OPTIONS_FORM || [],
    selectedProtectionPlan: selectedProtectionPlanWrapper(false)(state),
    messagesTexts: state.context.messagesTexts,
    selectedProductLot: initProductOptions(false)(state).selectedProductLot,
    additionalProtectionPlans: selectAdditionalProtectionPlans(false)(state),
    deviceType: state.context ? state.context.deviceType : {},
    addToCartInterstitialDetails: state.addToCartInterstitialDetails,
    productCollection: state.productCollection,
    featureFlags: selectFeatureFlags(state),
    myAlert: getMyAlerts(state),
    selectedSkuIds: selectSkuIds(state, ownProps.isBundle),
    productDetails: state.productDetails,
    sdpuStoreInfo: state.sdpuStoreInfo,
    deliveryOptionsName: state.deliveryOptionsName,
    isOpenSubSlidePanel: state.findStoresDetails && state.findStoresDetails.isOpenSubSlidePanel,
    findStoresDetails: state.findStoresDetails,
    queryParams: selectQueryParams(state),
    selectedSkuId: getSelectedProductSku(false)(state),
    sdpuStoreDetails: state.sdpuStoreInfo,
    storeFetchStatus: state.findStoresDetails && state.findStoresDetails.storeFetchStatus,
    serviceErrors: state.serviceErrors,
    isAddEditSlider: state.isAddEditSlider,
    isNative: state.context.isNative,
    isLoading: state.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...FindStoresAction,
            ...messagesActions,
            ...LoaderAction,
            ...ItemCountAction,
            ...OfferingsActions,
            ...MyAlertsModalAction,
            ...ATCInterstitalActions,
            /* Add To Cart Actions */
            addToCartOnClick,
            addToCartStickyOnClick,
            closeCartModal,
            /* Analytics Actions */
            formErrorAnalytics,
            cartUpdateAnalytics,
            openModalAnalytics,
            cartAddAnalytics,
            carePlanAcceptAnalytics,
            carePlanViewAnalytics,
            selectOptionsAnalytics,
        },
        dispatch
    ),
});

export default withRouter(
    compose(withAddToCartHOC(), connect(mapStateToProps, mapDispatchToProps))(AddToCart)
);
